export const ACCORDION_STATE = {
  MODE: {
    EDIT: 'edit',
    REVIEW: 'review',
  },
  OPEN_LABEL: {
    EXPAND_ALL: 'all',
    COLLAPSE_ALL: 'collapse',
    PARTIAL: 'partial',
  },
};
